import {Component, ElementRef, inject, input, model, OnInit, ViewChild} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as uuid from 'uuid';
import { LabelOptions } from '@core/classes/options/label-options';
import { TranslateService } from '@ngx-translate/core';
import { InputOptions } from '@shared/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export class SelectOptions {
  id?: string = uuid.v4();
  label?: LabelOptions;
  values?: { id: number | string; value: string }[];
  model?: number | string;
  onModelChange?: (value?: number | string) => void;
  required?: boolean;
  disabled?: boolean;

  constructor(args?: SelectOptions) {
    this.id = args?.id || uuid.v4();
    this.label = args?.label;
    this.values = args?.values;
    this.model = args?.model;
    this.onModelChange = args?.onModelChange;
    this.required = args?.required !== undefined ? args?.required : true;
    this.disabled = args?.disabled !== undefined ? args?.disabled : false;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-select',
  imports: [ReactiveFormsModule, FormsModule],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss',
})
export class SelectComponent implements OnInit {
  @ViewChild('selectEl') public selectElement!: ElementRef<HTMLSelectElement>;
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('select');
  protected invalidMessage: string = '';

  options = model(new SelectOptions());

  ngOnInit(): void {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('select');
    });
  }

  protected onModelChange = (value: number | string) => {
    this.options().model = value;
    this.options().onModelChange?.(value);
  };

  blur() {
    this.selectElement.nativeElement.blur();
  }
}
